export const host = window.location.host
export const mainDomain = host.split('.').slice(-2).join('.')

export let apiRootUrl = window.location.protocol + '//localhost:8087'
if (process.env.NODE_ENV !== 'development') {
  apiRootUrl = window.location.protocol + '//api-v1.' + mainDomain
}
